import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AppLayout } from "../../../components/layout/Header";
import { listAgentResponses } from "../../../js/api/agentResponseApi";
import { listBuyersForSession } from "../../../js/api/buyersApi";
import { useAgentScope } from "../../../js/hooks/useAgentScope";
import { useDesk } from "../../../js/hooks/useDesk";
import { formatDate, hasContent, prettyValue } from "../../../js/utils/formatters";
import { AGENT_RESPONSE_STEPS } from "../../../js/utils/agentResponseOptions";

export default function AgentResponseHub() {
  const { session, listAgentId, excludeAgentId } = useAgentScope();
  const desk = useDesk();
  const [responses, setResponses] = useState([]);
  const [buyers, setBuyers] = useState([]);

  useEffect(() => {
    listAgentResponses(listAgentId, excludeAgentId).then(setResponses);
    listBuyersForSession(session, listAgentId, excludeAgentId).then(setBuyers);
  }, [session, listAgentId, excludeAgentId]);

  const buyerName = (buyerId) => buyers.find((buyer) => buyer.id === buyerId)?.name || "Unassigned buyer";
  const shell = desk.variant === "broker" ? "broker" : "agent";

  return (
    <AppLayout variant={shell}>
      <div className="page-header">
        <div>
          <h1>Inquiry/Response</h1>
        </div>
        <Link to={desk.responseNew} className="pill-btn start-cta">
          New property response
        </Link>
      </div>
      <div className="stack">
        {responses.map((item) => {
          const filled = AGENT_RESPONSE_STEPS.filter((step) => hasContent(item[step.key])).length;
          const address = [item.property?.address, item.property?.city].filter(Boolean).join(", ") || "Address pending";
          return (
            <article key={item.id} className="card">
              <div className="page-header" style={{ marginBottom: 0 }}>
                <div>
                  <h2 style={{ marginBottom: "0.2rem" }}>
                    <Link to={desk.responsePath(item.id, "location")}>{address}</Link>
                  </h2>
                  <p className="muted">
                    {buyerName(item.buyerId)}
                    {item.property?.mls ? ` · MLS ${item.property.mls}` : ""}
                    {item.updatedAt ? ` · Updated ${formatDate(item.updatedAt)}` : ""}
                  </p>
                </div>
                <span className="badge">
                  {filled}/{AGENT_RESPONSE_STEPS.length} sections
                </span>
              </div>
              <p className="muted">
                {item.summary?.recommendation
                  ? prettyValue(item.summary.recommendation)
                  : "Recommendation not yet saved"}
              </p>
            </article>
          );
        })}
      </div>
    </AppLayout>
  );
}
